document.addEventListener("DOMContentLoaded", () => {
  (() => {
    const root = document.getElementById("sensual-quiz");
    if (!root) return;

    // ====== Tracking GA4 (Start / Complete / Intentions) ======
    function sqTrack(eventName, params = {}) {
      try {
        if (typeof window.gtag === "function") window.gtag("event", eventName, params);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: eventName, ...params });
      } catch (e) {}
    }

    // ====== Progress bar (FLOW DYNAMIQUE) ======
    const progressFill = document.getElementById("sq-progress-fill");

    function getFlowSteps() {
      // Avec ton nouveau HTML :
      // Steps possibles : 0,1,2(partner),3,4,5,6,7(adv), result
      // SOLO : 0,1,3,4,5,6,7
      // DUO  : 0,1,2,3,4,5,6,7
      if (intent === "solo") return ["0","1","3","4","5","6","7"];
      return ["0","1","2","3","4","5","6","7"];
    }

    function setProgressByStep(stepId) {
      if (!progressFill) return;
      if (String(stepId) === "result") {
        progressFill.style.width = "100%";
        return;
      }
      const flow = getFlowSteps();
      const idx = flow.indexOf(String(stepId));
      const total = flow.length || 1;
      const safeIdx = idx >= 0 ? idx : 0;
      const pct = Math.max(0, Math.min(100, ((safeIdx + 1) / total) * 100));
      progressFill.style.width = pct + "%";

      // mettre à jour le petit texte "Étape x/y" sur l'étape active si présent
      const activeStep = steps.find((s) => s.classList.contains("active"));
      if (activeStep) {
        const prog = activeStep.querySelector(".sq-progress");
        if (prog) prog.textContent = `Étape ${safeIdx + 1}/${total}`;
      }
    }

    // ====== State ======
    window.__sqUniverseCurrent = window.__sqUniverseCurrent || null;
    window.__sqQuizStarted = window.__sqQuizStarted || false;

    const steps = [...root.querySelectorAll(".sq-step")];
    const score = { decouverte: 0, sensations: 0, couple: 0, elegance: 0, avance: 0 };

    let gender = null;      // 'f' | 'h' | 'x'
    let intent = null;      // solo | me_with_partner | partner | together
    let partnerType = null; // 'h' | 'f' | 'any' (uniquement si intent != solo)

    // ====== Navigation arrière (anti double-score) ======
    const answersByStep = {}; // ex: answersByStep["3"] = {decouverte:2}
    function recomputeScore() {
      score.decouverte = 0;
      score.sensations = 0;
      score.couple = 0;
      score.elegance = 0;
      score.avance = 0;
      Object.keys(answersByStep).forEach((k) => {
        const pts = answersByStep[k];
        if (!pts) return;
        Object.keys(pts).forEach((u) => {
          if (score[u] !== undefined) score[u] += pts[u];
        });
      });
    }

    const QUIZ_SESSION_KEY = "sq_session_result_v3";
    function sessionRead() {
      try {
        return JSON.parse(sessionStorage.getItem(QUIZ_SESSION_KEY) || "null");
      } catch {
        return null;
      }
    }
    function sessionWrite(data) {
      try {
        sessionStorage.setItem(QUIZ_SESSION_KEY, JSON.stringify(data));
      } catch {}
    }
    function sessionClear() {
      try {
        sessionStorage.removeItem(QUIZ_SESSION_KEY);
      } catch {}
    }

    // ====== Boutons reset (haut + bas) ======
    const clearBtns = Array.from(
      root.querySelectorAll(
        "#sq-clear, #sq-clear-bottom, #sq-edit, #sq-edit-answers, [data-sq-clear], [data-sq-reset], [data-edit-answers]"
      )
    );

    function setClearVisible(v) {
      clearBtns.forEach((b) => {
        if ("hidden" in b) b.hidden = !v;
        else b.style.display = v ? "" : "none";
      });
    }

    // ====== Helpers UI : masquer réponses duo si solo ======
    function applyVisibilityRules() {
      const solo = intent === "solo";
      // tout bouton/élément marqué data-only="duo" est caché en solo
      root.querySelectorAll("[data-only='duo']").forEach((el) => {
        el.style.display = solo ? "none" : "";
      });

      // Step partenaire (data-step="2") caché si solo
      const stepPartner = steps.find((s) => String(s.dataset.step) === "2");
      if (stepPartner) stepPartner.style.display = solo ? "none" : "";
    }

    // ====== UI show (flow dynamique) ======
    function show(stepId) {
      const target = steps.find((s) => String(s.dataset.step) === String(stepId));
      if (!target) {
        console.warn("[SQ] step introuvable:", stepId);
        return;
      }

      applyVisibilityRules();

      steps.forEach((s) => s.classList.remove("active"));
      target.classList.add("active");

      // progress bar + texte étapes
      setProgressByStep(stepId);

      // gérer visibilité des boutons précédent selon flow réel
      root.querySelectorAll("[data-prev]").forEach((b) => (b.hidden = true));
      const prevBtn = target.querySelector("[data-prev]");
      if (prevBtn) {
        const flow = getFlowSteps();
        const idx = flow.indexOf(String(stepId));
        prevBtn.hidden = idx <= 0;
      }
    }

    // handler global "Précédent" (flow dynamique)
    root.querySelectorAll("[data-prev]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const stepEl = btn.closest(".sq-step");
        if (!stepEl) return;
        const cur = String(stepEl.dataset.step);
        const flow = getFlowSteps();
        const idx = flow.indexOf(cur);
        if (idx <= 0) return;
        show(flow[idx - 1]);
      });
    });

    async function fetchProduct(handle) {
      try {
        const r = await fetch(`/products/${handle}.js`, { cache: "no-store" });
        if (!r.ok) return null;
        return await r.json();
      } catch {
        return null;
      }
    }

    function money(c) {
      return (c / 100).toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
    }

    function bestImageUrl(p) {
      const imgs = Array.isArray(p.images) ? p.images : [];
      if (!imgs.length) return "";
      const first = imgs[0];
      const pick =
        imgs.find((u) => typeof u === "string" && /(_1024x1024|_800x800|_600x600|_480x480|_400x400|_360x360)/.test(u)) ||
        first;
      return pick;
    }

    function cardFromProductsJs(p, v) {
      const img = bestImageUrl(p);
      return `
      <div class="sq-prod">
        ${img ? `<img src="${img}" alt="${p.title}" loading="lazy">` : `<div style="height:220px;background:#fff"></div>`}
        <div class="b">
          <div class="t">${p.title}</div>
          <div class="p">${money(v.price)}</div>
          <div class="sq-row">
            <a class="sq-link" href="/products/${p.handle}" data-view-handle="${p.handle}">Voir</a>
            <a class="sq-link primary" href="#" data-add="${v.id}" data-add-handle="${p.handle}">Ajouter</a>
          </div>
        </div>
      </div>`;
    }

    function priceToCents(price) {
      if (typeof price === "string") {
        const n = parseFloat(price.replace(",", "."));
        return Number.isFinite(n) ? Math.round(n * 100) : 99999999;
      }
      if (typeof price === "number") {
        return price > 1000 ? Math.round(price) : Math.round(price * 100);
      }
      return 99999999;
    }

    function cardFromCollection(p, v) {
      const img = p.images && p.images.length ? p.images[0].src || p.images[0] : "";
      return `
      <div class="sq-prod">
        ${img ? `<img src="${img}" alt="${p.title}" loading="lazy">` : `<div style="height:220px;background:#fff"></div>`}
        <div class="b">
          <div class="t">${p.title}</div>
          <div class="p">${money(priceToCents(v.price))}</div>
          <div class="sq-row">
            <a class="sq-link" href="/products/${p.handle}" data-view-handle="${p.handle}">Voir</a>
            <a class="sq-link primary" href="#" data-add="${v.id}" data-add-handle="${p.handle}">Ajouter</a>
          </div>
        </div>
      </div>`;
    }

    function bindAdd(scope) {
      scope.querySelectorAll("[data-view-handle]").forEach((a) => {
        a.onclick = () => {
          try {
            sqTrack("quiz_product_view_click", {
              page_path: location.pathname,
              universe: window.__sqUniverseCurrent || "",
              handle: a.dataset.viewHandle || "",
              gender: gender || "",
              intent: intent || "",
              partner_type: partnerType || "",
            });
          } catch (e) {}
        };
      });

      scope.querySelectorAll("[data-add]").forEach((btn) => {
        btn.onclick = async (e) => {
          e.preventDefault();
          sqTrack("quiz_add_to_cart_click", {
            page_path: location.pathname,
            universe: window.__sqUniverseCurrent || "",
            handle: btn.dataset.addHandle || "",
            gender: gender || "",
            intent: intent || "",
            partner_type: partnerType || "",
          });

          btn.textContent = "Ajout…";
          try {
            const res = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: Number(btn.dataset.add), quantity: 1 }),
            });
            btn.textContent = res.ok ? "Ajouté" : "Erreur";
          } catch {
            btn.textContent = "Erreur";
          }
        };
      });
    }

    const _collectionCache = new Map();
    async function fetchCollectionProducts(handle) {
      if (_collectionCache.has(handle)) return _collectionCache.get(handle);
      try {
        const r = await fetch(`/collections/${handle}/products.json?limit=250`, { cache: "no-store" });
        if (!r.ok) {
          _collectionCache.set(handle, []);
          return [];
        }
        const data = await r.json();
        const prods = data.products || [];
        _collectionCache.set(handle, prods);
        return prods;
      } catch {
        _collectionCache.set(handle, []);
        return [];
      }
    }

    function firstAvailableVariant(p) {
      const vars = p.variants || [];
      return vars.find((v) => v.available) || null;
    }

    function norm(s) {
      return (s || "").toString().toLowerCase();
    }

    function matchKeywords(p, include = [], exclude = []) {
      const hay = norm(`${p.title || ""} ${(p.vendor || "")} ${(p.product_type || "")} ${(p.tags || []).join(" ")}`);
      if ((exclude || []).some((k) => hay.includes(norm(k)))) return false;
      if (!include || !include.length) return true;
      return include.some((k) => hay.includes(norm(k)));
    }

    // ====== Collections ======
    const COLLECTION_LUBS = "lubrifiants";
    const NEUTRE_MAX_CENTS = 2500;

    const COLLECTION_LINGERIE_F = "lingerie-femme";
    const COLLECTION_LINGERIE_H = "lingerie-homme";

    const COLLECTION_TOYS_MEN = "jouets-sexuels-pour-hommes";
    const COLLECTION_TOYS_COUPLES = "vibromasseur-pour-couples-ud";
    const COLLECTION_TOYS_WOMEN = "jouets-pour-femmes";
    const COLLECTION_TOYS_GLASS = "jouets-en-verre";
    const COLLECTION_TOYS_VIBRATORS = "vibrateurs";

    const FALLBACK_TOYS_SOFT_COLLECTIONS = ["stimulateurs", "vibrateurs", "sextoys"];
    const FALLBACK_TOYS_ADV_COLLECTIONS = ["sextoys"];

    const FALLBACK_ACC_SOFT_COLLECTIONS = ["plumes", "masques-et-menottes", "jeux", "fouets-a-coups-doux"];
    const FALLBACK_ACC_ADV_COLLECTIONS = [
      "pagaies-bdsm",
      "fouets-bdsm",
      "pinces-a-tetons-sadomasochisme",
      "masques-et-menottes",
    ];

    // ====== Filtres SOFT ======
    const SOFT_EXCLUDE = [
      "anal",
      "plug",
      "prostate",
      "prostat",
      "bdsm",
      "bondage",
      "pagaie",
      "paddle",
      "whip",
      "pinces",
      "téton",
      "teton",
      "sadomasoch",
      "sado",
      "gag",
      "bâillon",
      "baillon",
      "cage",
      "chastity",
      "fouet bdsm",
    ];
    const ADV_EXCLUDE = [];

    // ====== Filtre langues jeux ======
    const RE_LANG_SINGLE =
      /\b(ANGLAIS|ENGLISH|ESPAGNOL|ESPAÑOL|SPANISH|ITALIEN|ITALIAN|ITALIANO|ALLEMAND|DEUTSCH|GERMAN|PORTUGAIS|PORTUGUESE|PORTUGUÊS|NEERLANDAIS|DUTCH|NEDERLANDS)\b/i;
    const RE_LANG_LIST =
      /(?:\bFR\b|\bEN\b|\bES\b|\bIT\b|\bDE\b|\bPT\b|\bNL\b)\s*\/\s*(?:FR|EN|ES|IT|DE|PT|NL)(?:\s*\/\s*(?:FR|EN|ES|IT|DE|PT|NL))*/i;
    const RE_HAS_FR = /\bFR\b/i;
    function isFrenchOkForGameTitle(title) {
      const t = (title || "").toString();
      if (RE_LANG_SINGLE.test(t) && !RE_HAS_FR.test(t)) return false;
      if (RE_LANG_LIST.test(t) && !RE_HAS_FR.test(t)) return false;
      return true;
    }

    function passFrenchRuleIfGame(collectionHandle, productTitle) {
      if (collectionHandle !== "jeux") return true;
      return isFrenchOkForGameTitle(productTitle);
    }

    // ====== Limitation ANAL ======
    const RE_ANAL_STRICT = /(anal|plug|prostate|prostat|back\s*door)/i;
    const RE_VIBRATION = /(vibration|vibre|vibrant|vibrations|vibrateur|vibrating|vibe)/i;

    function maxAnalByUniverse(u) {
      if (u === "decouverte") return 0;
      if (u === "elegance") return 0;
      if (u === "avance") return 2;
      return 1;
    }

    // ====== Textes ======
    const COPY = {
      decouverte: {
        title: "Sélection Découverte",
        descBase: [
          "Vous êtes attiré(e) par ce qui rassure autant que ce qui excite.",
          "Ici, on cherche le frisson juste… celui qui donne envie de recommencer, sans jamais brusquer le corps.",
        ],
        descSoloF: "Une sélection douce, discrète, pensée pour vous guider et vous donner confiance dès les premières sensations.",
        descSoloH: "Une sélection simple, efficace, sans pression : du confort, du plaisir direct, et une progression naturelle.",
        descCouple:
          "Une sélection complice, facile à partager : de quoi créer l’ambiance, se rapprocher, et laisser le désir monter.",
        toysNote: "Trois essentiels accessibles, choisis pour démarrer sans vous tromper.",
        accNote: "Des compléments légers pour installer l’ambiance et enrichir l’expérience.",
      },
      sensations: {
        title: "Sélection Sensations",
        descBase: [
          "Vous aimez quand ça se ressent vraiment.",
          "Plus de textures, plus de montée, plus de précision… sans perdre le confort.",
        ],
        descSoloF: "Des choix orientés stimulation et plaisir personnel, pour une montée plus intense, à votre rythme.",
        descSoloH: "Des sensations plus franches, plus enveloppantes, pensées pour un plaisir masculin direct et satisfaisant.",
        descCouple: "Pour jouer à deux avec plus d’intensité : stimuler, surprendre, relancer le désir.",
        toysNote: "Trois choix orientés stimulation et montée en intensité.",
        accNote: "Des accessoires pour amplifier, varier et jouer avec les sensations.",
      },
      couple: {
        title: "Sélection Couple",
        descBase: [
          "Ce qui vous excite, c’est la connexion.",
          "Le regard, la surprise, le jeu… et ce moment où vous sentez que l’autre bascule aussi.",
        ],
        descSoloF:
          "Même en solo, vous aimez l’idée du rituel et de la complicité imaginaire : on soigne l’ambiance et la montée.",
        descSoloH:
          "Même en solo, vous aimez le côté « scénario » : un plaisir guidé, plus immersif, plus satisfaisant.",
        descCouple: "Pensée pour vous deux : plaisir partagé, consentement clair, et jeux simples à mettre en place.",
        toysNote: "Trois idées centrées sur l’interaction, la coordination, et le plaisir partagé.",
        accNote: "Des accessoires qui rendent le jeu naturel, fluide, et terriblement excitant.",
      },
      elegance: {
        title: "Sélection Élégance",
        descBase: [
          "Vous aimez quand c’est beau… et quand c’est bon.",
          "Matières, gestes, détails : l’excitation vient autant de l’ambiance que des sensations.",
        ],
        descSoloF: "Une sélection raffinée pour sublimer votre moment : esthétique, douceur, et plaisir assumé.",
        descSoloH: "Une sélection soignée, design, confortable : un plaisir masculin plus élégant, plus premium.",
        descCouple: "Pour une sensualité chic à deux : on suggère, on attire, on fait durer.",
        toysNote: "Trois propositions choisies pour leur style et leur expérience.",
        accNote: "Des détails qui subliment l’ambiance et prolongent le moment.",
      },
      avance: {
        title: "Exploration avancée",
        descBase: [
          "Vous êtes prêt(e) à aller plus loin.",
          "Plus de contrôle, plus d’abandon, plus de montée… toujours avec une logique progressive et consentie.",
        ],
        descSoloF: "Une sélection plus affirmée, à apprivoiser à votre rythme, pour explorer des sensations nouvelles.",
        descSoloH: "Une sélection masculine plus audacieuse, pensée pour des sensations plus intenses et plus enveloppantes.",
        descCouple: "Pour pimenter à deux : jeux plus audacieux, mais toujours maîtrisés et faciles à cadrer.",
        toysNote: "Trois choix plus affirmés, à apprivoiser à votre rythme.",
        accNote: "Des accessoires orientés jeu et intensification, toujours avec maîtrise.",
      },
    };

    const UNIVERSE_SOURCES = {
      decouverte: {
        toys: {
          collections: ["stimulateurs", "vibrateurs", "sextoys"],
          include: ["mini", "discret", "douce", "soft", "début", "debut", "starter", "coffret", "kit", "compact", "tendre"],
          exclude: SOFT_EXCLUDE,
        },
        accessories: {
          collections: ["plumes", "masques-et-menottes", "jeux"],
          include: ["plume", "tickle", "masque", "menottes", "fourrure", "dés", "des", "cartes", "jeu", "roulette", "dominos"],
          exclude: SOFT_EXCLUDE,
        },
      },
      sensations: {
        toys: {
          collections: ["stimulateurs", "vibrateurs", "sextoys"],
          include: ["ondes", "pression", "suction", "wand", "intense", "rabbit", "double", "point g", "stimulation", "clitoris", "vibrat"],
          exclude: SOFT_EXCLUDE,
        },
        accessories: {
          collections: ["plumes", "masques-et-menottes", "fouets-a-coups-doux", "jeux"],
          include: ["masque", "menottes", "fouet", "crop", "plume", "jeu", "dés", "des", "cartes", "roulette"],
          exclude: SOFT_EXCLUDE,
        },
      },
      couple: {
        toys: {
          collections: ["stimulateurs", "vibrateurs", "sextoys"],
          include: ["couple", "duo", "télécommande", "telecommande", "remote", "app", "connect", "ensemble", "partagé", "partage"],
          exclude: SOFT_EXCLUDE,
        },
        accessories: {
          collections: ["jeux", "masques-et-menottes", "plumes", "fouets-a-coups-doux"],
          include: ["jeu", "cartes", "dés", "des", "roulette", "dominos", "masque", "menottes", "plume", "fouet"],
          exclude: SOFT_EXCLUDE,
        },
      },
      elegance: {
        toys: {
          collections: ["stimulateurs", "vibrateurs", "sextoys"],
          include: ["design", "premium", "luxe", "élégant", "elegant", "rechargeable", "silicone", "raffiné", "raffine"],
          exclude: SOFT_EXCLUDE,
        },
        accessories: {
          collections: ["plumes", "masques-et-menottes", "jeux", "fouets-a-coups-doux"],
          include: ["plume", "masque", "menottes", "jeu", "cartes", "dés", "des", "fouet"],
          exclude: SOFT_EXCLUDE,
        },
      },
      avance: {
        toys: {
          collections: ["sextoys"],
          include: ["anal", "plug", "prostate", "bdsm", "bondage", "cage", "chastity", "ring", "anneau"],
          exclude: ADV_EXCLUDE,
        },
        accessories: {
          collections: ["pagaies-bdsm", "fouets-bdsm", "pinces-a-tetons-sadomasochisme", "masques-et-menottes", "jeux"],
          include: ["pagaie", "paddle", "fouet", "whip", "pinces", "téton", "teton", "bdsm", "bondage", "masque", "menottes", "jeu", "cartes", "dés", "des", "roulette"],
          exclude: ADV_EXCLUDE,
        },
      },
    };

    const PARTNER_UNIVERSE_FILTERS = {
      decouverte: {
        include: ["mini", "discret", "soft", "doux", "douce", "starter", "début", "debut", "compact", "simple"],
        exclude: ["bdsm", "bondage", "harnais", "latex", "vinyle", "chastity", "cage", "gag", "bâillon", "baillon"],
      },
      sensations: {
        include: ["vibr", "wand", "rabbit", "double", "intense", "suction", "pression", "ondes", "stimulation", "clitoris", "point g", "g-spot"],
        exclude: ["bdsm", "bondage", "chastity", "cage", "gag", "bâillon", "baillon"],
      },
      couple: {
        include: ["couple", "duo", "télécommande", "telecommande", "remote", "app", "connect", "ensemble", "partagé", "partage"],
        exclude: ["chastity", "cage", "gag", "bâillon", "baillon"],
      },
      elegance: {
        include: ["design", "premium", "luxe", "élégant", "elegant", "rechargeable", "silicone", "raffiné", "raffine", "dentelle", "satin", "soie", "chic"],
        exclude: ["bdsm", "bondage", "harnais", "latex", "vinyle", "chastity", "cage", "gag", "bâillon", "baillon"],
      },
      avance: {
        include: ["bdsm", "bondage", "latex", "vinyle", "harnais", "menottes", "collier", "anal", "plug"],
        exclude: [],
      },
    };

    function universeFilterForPartner(u) {
      return PARTNER_UNIVERSE_FILTERS[u] || PARTNER_UNIVERSE_FILTERS.sensations;
    }

    function scorePartnerProductByUniverse(p, universe) {
      const cfg = universeFilterForPartner(universe);
      const hay = norm(`${p.title || ""} ${(p.vendor || "")} ${(p.product_type || "")} ${(p.tags || []).join(" ")}`);

      let s = 0;
      (cfg.include || []).forEach((k) => {
        if (hay.includes(norm(k))) s += 2;
      });
      (cfg.exclude || []).forEach((k) => {
        if (hay.includes(norm(k))) s -= 4;
      });

      if (universe === "couple" && /couple|duo|telecommande|télécommande|remote|app|connect/.test(hay)) s += 4;
      if (universe === "elegance" && /design|premium|luxe|elegant|élégant|raffin|chic/.test(hay)) s += 3;
      if (universe === "sensations" && /vibr|intense|wand|rabbit|double|suction|ondes/.test(hay)) s += 3;
      if (universe === "decouverte" && /mini|soft|doux|début|debut|starter|compact/.test(hay)) s += 3;

      s += Math.random() * 0.25;
      return s;
    }

    // ====== Pools ======
    async function buildPoolFromSources(source, size = 10, fallback = null) {
      const { collections = [], include = [], exclude = [] } = source || {};
      const all = [];

      for (const c of collections) {
        const prods = await fetchCollectionProducts(c);
        for (const p of prods) {
          const v = firstAvailableVariant(p);
          if (!v) continue;
          if (!passFrenchRuleIfGame(c, p.title)) continue;
          if (!matchKeywords(p, include, exclude)) continue;
          all.push(p.handle);
        }
      }

      let uniq = [...new Set(all)].sort(() => 0.5 - Math.random());
      if (uniq.length >= size) return uniq.slice(0, size);

      if (fallback) {
        const { collections: fbCols = [], include: fbInc = [], exclude: fbExc = [] } = fallback;
        for (const c of fbCols) {
          const prods = await fetchCollectionProducts(c);
          for (const p of prods) {
            const v = firstAvailableVariant(p);
            if (!v) continue;
            if (!passFrenchRuleIfGame(c, p.title)) continue;
            if (!matchKeywords(p, fbInc, fbExc)) continue;
            uniq.push(p.handle);
          }
        }
        uniq = [...new Set(uniq)].sort(() => 0.5 - Math.random());
      }

      return uniq.slice(0, size);
    }

    const POOL_CACHE_KEY = "sq_pools_v1";
    const POOL_CACHE_TTL_MS = 24 * 60 * 60 * 1000;
    function poolCacheRead() {
      try {
        return JSON.parse(localStorage.getItem(POOL_CACHE_KEY) || "{}");
      } catch {
        return {};
      }
    }
    function poolCacheWrite(obj) {
      try {
        localStorage.setItem(POOL_CACHE_KEY, JSON.stringify(obj));
      } catch {}
    }

    async function getUniversePools(universe) {
      const cache = poolCacheRead();
      const now = Date.now();
      const entry = cache[universe];

      if (entry && entry.ts && now - entry.ts < POOL_CACHE_TTL_MS && entry.toys?.length && entry.accessories?.length) {
        return entry;
      }

      const src = UNIVERSE_SOURCES[universe];
      const isAdvanced = universe === "avance";

      const toysFallback = isAdvanced
        ? { collections: FALLBACK_TOYS_ADV_COLLECTIONS, include: [], exclude: ADV_EXCLUDE }
        : { collections: FALLBACK_TOYS_SOFT_COLLECTIONS, include: [], exclude: SOFT_EXCLUDE };

      const accFallback = isAdvanced
        ? { collections: FALLBACK_ACC_ADV_COLLECTIONS.concat(["jeux"]), include: [], exclude: ADV_EXCLUDE }
        : { collections: FALLBACK_ACC_SOFT_COLLECTIONS, include: [], exclude: SOFT_EXCLUDE };

      const toys = await buildPoolFromSources(src.toys, 10, toysFallback);
      const accessories = await buildPoolFromSources(src.accessories, 10, accFallback);

      const fresh = { ts: now, toys, accessories };
      cache[universe] = fresh;
      poolCacheWrite(cache);
      return fresh;
    }

    // ====== Rotation mémoire ======
    const MEM_KEY = "sq_recent_v2";
    const MEM_MAX = 30;

    function memRead() {
      try {
        return JSON.parse(localStorage.getItem(MEM_KEY) || "{}");
      } catch {
        return {};
      }
    }
    function memWrite(obj) {
      try {
        localStorage.setItem(MEM_KEY, JSON.stringify(obj));
      } catch {}
    }
    function memGet(scope, kind) {
      const m = memRead();
      return (m?.[scope]?.[kind] || []).filter(Boolean);
    }
    function memPush(scope, kind, handles) {
      const m = memRead();
      m[scope] = m[scope] || {};
      const prev = (m[scope][kind] || []).filter(Boolean);
      const next = [...handles, ...prev].filter((h, i, arr) => arr.indexOf(h) === i).slice(0, MEM_MAX);
      m[scope][kind] = next;
      memWrite(m);
    }
    function orderWithRecent(handles, recentSet) {
      const uniq = [...new Set(handles)];
      const fresh = uniq.filter((h) => !recentSet.has(h)).sort(() => 0.5 - Math.random());
      const old = uniq.filter((h) => recentSet.has(h)).sort(() => 0.5 - Math.random());
      return [...fresh, ...old];
    }

    // ====== render pool cards ======
    async function renderPoolCards(gridEl, handles, limit = 3, scope = null, kind = null) {
      gridEl.innerHTML = "";
      const recent = scope && kind ? new Set(memGet(scope, kind)) : new Set();
      const ordered = scope && kind ? orderWithRecent(handles, recent) : [...new Set(handles)].sort(() => 0.5 - Math.random());

      const picked = [];
      let count = 0;

      for (const h of ordered) {
        if (count >= limit) break;
        const p = await fetchProduct(h);
        if (!p) continue;
        const v = p.variants.find((v) => v.available);
        if (!v) continue;
        gridEl.innerHTML += cardFromProductsJs(p, v);
        picked.push(h);
        count++;
      }

      if (scope && kind && picked.length) memPush(scope, kind, picked);
      bindAdd(gridEl);
      return picked;
    }

    async function renderToysCardsLimitedAnal(gridEl, handles, universe, limit = 3, scope = null, kind = null) {
      gridEl.innerHTML = "";
      const recent = scope && kind ? new Set(memGet(scope, kind)) : new Set();
      const ordered = scope && kind ? orderWithRecent(handles, recent) : [...new Set(handles)].sort(() => 0.5 - Math.random());

      const picked = [];
      let count = 0;
      let analCount = 0;
      const analMax = maxAnalByUniverse(universe);

      for (const h of ordered) {
        if (count >= limit) break;
        const p = await fetchProduct(h);
        if (!p) continue;
        const v = p.variants.find((v) => v.available);
        if (!v) continue;

        const title = (p.title || "").toString();
        const isAnal = RE_ANAL_STRICT.test(title);

        if (isAnal && analCount >= analMax) continue;
        if (isAnal) analCount++;

        gridEl.innerHTML += cardFromProductsJs(p, v);
        picked.push(h);
        count++;
      }

      if (scope && kind && picked.length) memPush(scope, kind, picked);
      bindAdd(gridEl);
      return picked;
    }

    // ====== Custom pool sextoys selon gender/intent ======
    async function getCustomToyHandles(universe) {
      const u = universe || root.dataset.base || "sensations";

      if (intent === "together") {
        const prods = await fetchCollectionProducts(COLLECTION_TOYS_COUPLES);
        const handles = (prods || [])
          .filter((p) => !!firstAvailableVariant(p))
          .map((p) => p.handle);
        return [...new Set(handles)].slice(0, 50);
      }

      if (gender === "h") {
        if (intent === "solo") {
          const prods = await fetchCollectionProducts(COLLECTION_TOYS_MEN);
          const handles = (prods || [])
            .filter((p) => !!firstAvailableVariant(p))
            .map((p) => p.handle);
          return [...new Set(handles)].slice(0, 50);
        }

        if (intent === "me_with_partner") {
          const prods = await fetchCollectionProducts(COLLECTION_TOYS_MEN);
          const handles = (prods || [])
            .filter((p) => !!firstAvailableVariant(p))
            .filter((p) => RE_VIBRATION.test((p.title || "").toString()))
            .map((p) => p.handle);

          if (handles.length < 6) {
            const more = (prods || [])
              .filter((p) => !!firstAvailableVariant(p))
              .filter((p) => /vibr/i.test((p.title || "").toString()))
              .map((p) => p.handle);
            return [...new Set(handles.concat(more))].slice(0, 50);
          }

          return [...new Set(handles)].slice(0, 50);
        }

        if (intent === "partner") {
          const cols = [COLLECTION_TOYS_WOMEN, COLLECTION_TOYS_GLASS, COLLECTION_TOYS_VIBRATORS];
          let items = [];

          for (const c of cols) {
            const prods = await fetchCollectionProducts(c);
            (prods || []).forEach((p) => {
              if (!firstAvailableVariant(p)) return;
              items.push(p);
            });
          }

          items = items
            .slice()
            .sort((a, b) => scorePartnerProductByUniverse(b, u) - scorePartnerProductByUniverse(a, u));

          const handles = items.map((p) => p.handle);
          return [...new Set(handles)].slice(0, 50);
        }

        return null;
      }

      return null;
    }

    // ====== Helpers gels/lingerie (inchangé) ======
    function pickByRotation(items, scope, kind, avoidHandles) {
      const avoid = new Set(avoidHandles || []);
      const recent = new Set(memGet(scope, kind));
      const handles = items.map((x) => x.p.handle);
      const orderedHandles = orderWithRecent(handles, recent);

      for (const h of orderedHandles) {
        if (avoid.has(h)) continue;
        const found = items.find((x) => x.p.handle === h);
        if (found) return found;
      }
      for (const it of items) {
        if (!avoid.has(it.p.handle)) return it;
      }
      return null;
    }

    async function renderGels(universe) {
      const grid = document.getElementById("sq-gels");
      if (!grid) return [];
      grid.innerHTML = "";

      const products = await fetchCollectionProducts(COLLECTION_LUBS);
      if (!products.length) return [];

      const RE_WATER = /(à base d'eau|a base d'eau|water[-\s]?based|base d eau|waterbased)/i;
      const RE_NEUTRE = /(neutre|classic|classique|naturel|natural|bio|organic|aloe|hydratant|sensitive|peaux sensibles)/i;
      const RE_SENSITIVE = /(sensitive|peaux sensibles|hypoallergen|hypo-allergen|dermatolog|sans parfum|sans glycérine|sans glycerine)/i;

      const RE_EFFECT = /(chauffant|warming|froid|cooling|picotant|tingling|vibrant|effet|stimulant|stimulating|intense|sensation)/i;
      const RE_ORGASM = /(orgasm|orgasme|climax|enhancer|intensif|intensifier|intensificateur)/i;

      const RE_MASSAGE = /(massage|huile|oil|glissant|relax|sensuel|sensoriel)/i;
      const RE_LONG = /(longue durée|longue duree|long[-\s]?lasting|durable|épais|epais|thick|gel épais|gel epais)/i;

      const RE_ANAL = /(anal|back\s*door|prostat|prostate)/i;

      const all = products
        .map((p) => ({ p, v: firstAvailableVariant(p) }))
        .filter((x) => x.v);

      function bucket(regex, extraFn) {
        return all.filter(({ p, v }) => {
          const hay = `${p.title || ""} ${p.product_type || ""} ${(p.tags || []).join(" ")}`;
          if (regex && !regex.test(hay)) return false;
          if (extraFn && !extraFn(p, v)) return false;
          return true;
        });
      }

      const neutres = bucket(null, (p, v) => {
        const hay = `${p.title || ""} ${p.product_type || ""} ${(p.tags || []).join(" ")}`;
        const ok = RE_WATER.test(hay) || RE_NEUTRE.test(hay);
        return ok && priceToCents(v.price) <= NEUTRE_MAX_CENTS;
      });

      const sensitive = bucket(RE_SENSITIVE, (p, v) => priceToCents(v.price) <= NEUTRE_MAX_CENTS);
      const effects = bucket(RE_EFFECT);
      const orgasms = bucket(RE_ORGASM);
      const massages = bucket(RE_MASSAGE);
      const longs = bucket(RE_LONG);
      const anals = bucket(RE_ANAL);

      const scope = "gels:" + (universe || "soft");
      const chosen = [];
      const usedHandles = [];

      function pickFrom(list, kind) {
        const it = pickByRotation(list, scope, kind, usedHandles);
        if (it) {
          chosen.push(it);
          usedHandles.push(it.p.handle);
        }
      }

      pickFrom(neutres.length ? neutres : all, "neutre");

      const u = universe || root.dataset.base || "sensations";

      if (u === "decouverte") {
        pickFrom(sensitive.length ? sensitive : neutres, "sensitive");
        pickFrom(neutres.length ? neutres : all, "douceur");
      } else if (u === "sensations") {
        pickFrom(effects.length ? effects : orgasms, "effet");
        pickFrom(orgasms.length ? orgasms : effects, "orgasm");
      } else if (u === "couple") {
        pickFrom(massages.length ? massages : effects, "massage");
        pickFrom(longs.length ? longs : neutres, "longue_duree");
      } else if (u === "elegance") {
        pickFrom(massages.length ? massages : neutres, "sensoriel");
        pickFrom(neutres.length ? neutres : longs, "soft_premium");
      } else if (u === "avance") {
        pickFrom(anals.length ? anals : longs, "anal");
        pickFrom(longs.length ? longs : effects, "longue_duree");
      } else {
        pickFrom(effects.length ? effects : neutres, "effet_fb");
        pickFrom(longs.length ? longs : neutres, "long_fb");
      }

      while (chosen.length < 3) {
        const fb = pickByRotation(all, scope, "fallback", usedHandles);
        if (!fb) break;
        chosen.push(fb);
        usedHandles.push(fb.p.handle);
      }

      memPush(scope, "shown", chosen.map((x) => x.p.handle));

      for (const item of chosen.slice(0, 3)) {
        grid.innerHTML += cardFromCollection(item.p, item.v);
      }
      bindAdd(grid);
      return chosen.slice(0, 3).map((x) => x.p.handle);
    }

    function getLingerieMixPlan(gender, intent) {
      const g = gender === "h" ? "h" : "f";
      const mine = g === "h" ? COLLECTION_LINGERIE_H : COLLECTION_LINGERIE_F;
      const other = g === "h" ? COLLECTION_LINGERIE_F : COLLECTION_LINGERIE_H;

      const plan = [];
      if (intent === "solo") {
        plan.push({ col: mine, count: 3 });
      } else if (intent === "partner") {
        plan.push({ col: other, count: 2 });
        plan.push({ col: mine, count: 1 });
      } else if (intent === "me_with_partner") {
        plan.push({ col: mine, count: 2 });
        plan.push({ col: other, count: 1 });
      } else if (intent === "together") {
        plan.push({ col: mine, count: 1 });
        plan.push({ col: other, count: 1 });
        plan.push({ col: mine, count: 1 });
      } else {
        plan.push({ col: mine, count: 3 });
      }

      const total = plan.reduce((s, x) => s + (x.count || 0), 0);
      if (total !== 3 && total > 0) {
        if (total > 3) {
          let extra = total - 3;
          for (const p of plan) {
            while (extra > 0 && p.count > 0) {
              p.count -= 1;
              extra--;
            }
            if (extra <= 0) break;
          }
        } else if (total < 3) {
          plan[0].count += 3 - total;
        }
      }
      return plan.filter((x) => x.count > 0);
    }

    async function renderLingerie(universe) {
      const grid = document.getElementById("sq-lingerie");
      if (!grid) return [];
      grid.innerHTML = "";

      const u = universe || root.dataset.base || "sensations";

      const RE_ELEG = /(dentelle|satin|soie|lace|élégant|elegant|raffin|chic|premium)/i;
      const RE_CPL = /(ouvert|ouverture|open|coquin|sexy|provoc|roleplay|déguis|deguis|costume)/i;
      const RE_DISC = /(confort|soft|doux|cotton|coton|simple|basic|début|debut)/i;
      const RE_ADV = /(harnais|cuir|latex|vinyle|strap|collier|menottes|bdsm)/i;

      function scoreItem(item) {
        const hay = `${item.p.title || ""} ${item.p.product_type || ""} ${(item.p.tags || []).join(" ")}`;
        let s = 0;

        const coupleLike = intent === "together" || intent === "me_with_partner" || intent === "partner";
        if (coupleLike) s += 1;

        if (u === "elegance") {
          if (RE_ELEG.test(hay)) s += 4;
          if (RE_CPL.test(hay)) s += 1;
          if (RE_ADV.test(hay)) s -= 3;
        } else if (u === "couple") {
          if (RE_CPL.test(hay)) s += 4;
          if (RE_ELEG.test(hay)) s += 1;
        } else if (u === "decouverte") {
          if (RE_DISC.test(hay)) s += 4;
          if (RE_CPL.test(hay)) s -= 1;
          if (RE_ADV.test(hay)) s -= 5;
        } else if (u === "sensations") {
          if (RE_CPL.test(hay)) s += 3;
          if (RE_ELEG.test(hay)) s += 1;
        } else if (u === "avance") {
          if (RE_ADV.test(hay)) s += 4;
          if (RE_CPL.test(hay)) s += 2;
        }

        s += Math.random() * 0.25;
        return s;
      }

      const plan = getLingerieMixPlan(gender, intent);

      const perCol = {};
      for (const part of plan) {
        const prods = await fetchCollectionProducts(part.col);
        const items = (prods || [])
          .map((p) => ({ p, v: firstAvailableVariant(p) }))
          .filter((x) => x.v)
          .sort((a, b) => scoreItem(b) - scoreItem(a));
        perCol[part.col] = items;
      }

      const selected = [];
      const used = new Set();

      function takeFrom(col, n) {
        const items = perCol[col] || [];
        for (const it of items) {
          if (selected.length >= 3) break;
          if (n <= 0) break;
          const h = it.p.handle;
          if (used.has(h)) continue;
          selected.push(h);
          used.add(h);
          n--;
        }
      }

      for (const part of plan) {
        if (selected.length >= 3) break;
        takeFrom(part.col, part.count);
      }

      if (selected.length < 3) {
        const cols = [COLLECTION_LINGERIE_F, COLLECTION_LINGERIE_H];
        for (const col of cols) {
          if (!perCol[col]) {
            const prods = await fetchCollectionProducts(col);
            perCol[col] = (prods || [])
              .map((p) => ({ p, v: firstAvailableVariant(p) }))
              .filter((x) => x.v)
              .sort((a, b) => scoreItem(b) - scoreItem(a));
          }
        }
        const merged = [...(perCol[COLLECTION_LINGERIE_F] || []), ...(perCol[COLLECTION_LINGERIE_H] || [])]
          .sort((a, b) => scoreItem(b) - scoreItem(a))
          .map((x) => x.p.handle);

        for (const h of merged) {
          if (selected.length >= 3) break;
          if (used.has(h)) continue;
          selected.push(h);
          used.add(h);
        }
      }

      const scope = `lingerie:${gender || "f"}:${intent || "solo"}:${u}`;
      const picked = await renderPoolCards(grid, selected, 3, scope, "shown");
      return picked || [];
    }

    function buildResultHtml(universe) {
      const c = COPY[universe] || COPY.sensations;
      const base = (c.descBase || []).map((s) => `<p>${s}</p>`).join("");
      let spec = "";

      const coupleLike = intent === "together" || intent === "me_with_partner" || intent === "partner";
      if (!gender) gender = "f";

      if (coupleLike) {
        spec = `<p>${c.descCouple}</p>`;
      } else {
        spec = gender === "h" ? `<p>${c.descSoloH}</p>` : `<p>${c.descSoloF}</p>`;
      }

      const reassure =
        `<p><strong>Conseil :</strong> commencez par ce qui vous donne envie maintenant. Vous pourrez toujours faire évoluer l’intensité ensuite.</p>`;
      return base + spec + reassure;
    }

    async function renderUniverse(universe) {
      window.__sqUniverseCurrent = universe;

      sqTrack("quiz_complete", {
        page_path: location.pathname,
        universe: universe,
        gender: gender || "",
        intent: intent || "",
        partner_type: partnerType || "",
      });

      const c = COPY[universe] || COPY.sensations;

      const titleEl = document.getElementById("sq-title");
      const descEl = document.getElementById("sq-desc");
      const toysNoteEl = document.getElementById("sq-toys-note");
      const accNoteEl = document.getElementById("sq-acc-note");

      if (titleEl) titleEl.innerText = c.title;
      if (descEl) descEl.innerHTML = buildResultHtml(universe);
      if (toysNoteEl) toysNoteEl.innerText = c.toysNote;
      if (accNoteEl) accNoteEl.innerText = c.accNote;

      const toysGrid = document.getElementById("sq-products");
      const accGrid = document.getElementById("sq-accessories");

      const pools = await getUniversePools(universe);

      const customToyHandles = await getCustomToyHandles(universe);
      const toysHandlesFinal = customToyHandles && customToyHandles.length ? customToyHandles : pools.toys;

      const pickedToys = toysGrid
        ? await renderToysCardsLimitedAnal(
            toysGrid,
            toysHandlesFinal,
            universe,
            3,
            "toys:" + universe + ":" + (gender || "") + ":" + (intent || "") + ":" + (partnerType || ""),
            "toys"
          )
        : [];

      const pickedAcc = accGrid
        ? await renderPoolCards(accGrid, pools.accessories, 3, "universe:" + universe, "acc")
        : [];

      const pickedGels = await renderGels(universe);
      const pickedLing = await renderLingerie(universe);

      sessionWrite({
        universe,
        gender,
        intent,
        partnerType,
        picked: {
          toys: pickedToys || [],
          accessories: pickedAcc || [],
          gels: pickedGels || [],
          lingerie: pickedLing || [],
        },
        ts: Date.now(),
      });

      setClearVisible(true);
    }

    async function restoreFromSession() {
      const s = sessionRead();
      if (!s || !s.universe || !s.picked) return false;

      gender = s.gender || null;
      intent = s.intent || null;
      partnerType = s.partnerType || null;

      applyVisibilityRules();

      show("result");
      const u = s.universe;
      window.__sqUniverseCurrent = u;

      const c = COPY[u] || COPY.sensations;

      const titleEl = document.getElementById("sq-title");
      const descEl = document.getElementById("sq-desc");
      const toysNoteEl = document.getElementById("sq-toys-note");
      const accNoteEl = document.getElementById("sq-acc-note");

      if (titleEl) titleEl.innerText = c.title;
      if (descEl) descEl.innerHTML = buildResultHtml(u);
      if (toysNoteEl) toysNoteEl.innerText = c.toysNote;
      if (accNoteEl) accNoteEl.innerText = c.accNote;

      const toysGrid = document.getElementById("sq-products");
      const accGrid = document.getElementById("sq-accessories");
      const gelsGrid = document.getElementById("sq-gels");
      const lingGrid = document.getElementById("sq-lingerie");

      if (toysGrid) await renderPoolCards(toysGrid, s.picked.toys || [], 3, null, null);
      if (accGrid) await renderPoolCards(accGrid, s.picked.accessories || [], 3, null, null);

      async function renderForced(gridEl, handles) {
        if (!gridEl) return;
        gridEl.innerHTML = "";
        let count = 0;
        for (const h of handles || []) {
          if (count >= 3) break;
          const p = await fetchProduct(h);
          if (!p) continue;
          const v = p.variants.find((v) => v.available) || p.variants[0];
          if (!v) continue;
          gridEl.innerHTML += cardFromProductsJs(p, v);
          count++;
        }
        bindAdd(gridEl);
      }

      await renderForced(gelsGrid, s.picked.gels || []);
      await renderForced(lingGrid, s.picked.lingerie || []);

      setClearVisible(true);
      return true;
    }

    function resetQuiz() {
      sessionClear();
      Object.keys(score).forEach((k) => (score[k] = 0));
      Object.keys(answersByStep).forEach((k) => delete answersByStep[k]);

      gender = null;
      intent = null;
      partnerType = null;

      root.dataset.base = "";
      setClearVisible(false);
      window.__sqUniverseCurrent = null;
      window.__sqQuizStarted = false;

      applyVisibilityRules();
      show("0");
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    clearBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        resetQuiz();
      });
    });

    // ====== Click handlers ======

    // Step 0: gender
    root.querySelectorAll(".sq-btn[data-gender]").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (!window.__sqQuizStarted) {
          window.__sqQuizStarted = true;
          sqTrack("quiz_start", { page_path: location.pathname });
        }
        gender = btn.dataset.gender; // f/h/x
        sqTrack("quiz_gender", { page_path: location.pathname, gender });
        show("1");
      });
    });

    // Step 1: intent (inchangé) MAIS -> conditionne l'affichage du step partenaire (2)
    root.querySelectorAll(".sq-btn[data-intent]").forEach((btn) => {
      btn.addEventListener("click", () => {
        intent = btn.dataset.intent; // solo | me_with_partner | partner | together

        // si solo, pas de partenaire
        if (intent === "solo") partnerType = null;

        applyVisibilityRules();

        sqTrack("quiz_intent", { page_path: location.pathname, intent, gender: gender || "" });

        // navigation :
        // - solo -> on saute partner step (2) et on va au scoring step 3
        // - duo  -> on va au step 2 partenaire
        if (intent === "solo") show("3");
        else show("2");
      });
    });

    // Step 2 (NEW): partner type
    root.querySelectorAll(".sq-btn[data-partner]").forEach((btn) => {
      btn.addEventListener("click", () => {
        if (intent === "solo") return;
        partnerType = btn.dataset.partner; // h|f|any

        sqTrack("quiz_partner_type", {
          page_path: location.pathname,
          partner_type: partnerType || "",
          intent: intent || "",
          gender: gender || "",
        });

        show("3");
      });
    });

    // Steps scoring : maintenant ce sont les steps 3..6 (après insertion du step partenaire)
    root.querySelectorAll(".sq-btn[data-p]").forEach((btn) => {
      btn.addEventListener("click", () => {
        // ignore si bouton caché par règle (sécurité)
        if (btn.closest("[data-only='duo']") && intent === "solo") return;

        const pts = JSON.parse(btn.dataset.p);
        const stepEl = btn.closest(".sq-step");
        const step = stepEl ? String(stepEl.dataset.step) : null;
        if (step === null) return;

        answersByStep[String(step)] = pts;
        recomputeScore();

        // la dernière question de scoring est maintenant step "6"
        // puis on va au step 7 (ADV)
        if (step === "6") {
          const u = Object.keys(score).reduce((a, b) => (score[a] > score[b] ? a : b));
          root.dataset.base = u;
          show("7");
        } else {
          // flow: step suivant normal, mais en solo on n'utilise pas 2 de toute façon
          show(String(Number(step) + 1));
        }
      });
    });

    // Step 7: advanced (ancien step 6 -> devenu 7)
    root.querySelectorAll("[data-adv]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const base = root.dataset.base || "sensations";
        const u = btn.dataset.adv === "yes" ? "avance" : base;
        show("result");
        renderUniverse(u);
      });
    });

    // Init
    applyVisibilityRules();
    show("0");

    // Restore session if any
    const restored = restoreFromSession();
    Promise.resolve(restored).then((ok) => {
      if (!ok) setClearVisible(false);
    });
  })();
});